import { render } from "./MySchedules.vue?vue&type=template&id=8050b99c&scoped=true"
import script from "./MySchedules.vue?vue&type=script&lang=js"
export * from "./MySchedules.vue?vue&type=script&lang=js"

import "./MySchedules.vue?vue&type=style&index=0&id=8050b99c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8050b99c"]])

export default __exports__